<script setup lang="ts">
import { ref, computed } from 'vue';
import { loadLanguageAsync, getActiveLanguage } from 'laravel-vue-i18n';
import { router, usePage } from "@inertiajs/vue3";
import { PagePropsInterface } from "@interfaces/PagePropsInterface.ts";

interface langObject {
    code: string;
    name: string;
}

let page = usePage<PagePropsInterface>();

const languages: langObject[] = usePage().props.languages;

const activeLangCode = ref(getActiveLanguage() ?? languages[0].code);
const showDropdown = ref(false);

const activeLanguage = computed(() => languages.find(lang => lang.code === activeLangCode.value));

const onSelectLanguage = async (langCode: string): Promise<void> => {
    if (langCode === activeLangCode.value) {
        return;
    }

    const currentRouteName = route().current();
    const currentRouteParameters = route().params;
    const newRoute = route(`${currentRouteName.replace(activeLangCode.value, langCode)}`, currentRouteParameters);

    activeLangCode.value = langCode;
    await loadLanguageAsync(langCode);
    showDropdown.value = false;

    router.get(newRoute, {}, { replace: true });
};
</script>

<template>
    <div class="relative text-gray-500">
        <button @click="showDropdown = !showDropdown">
            <p
            :class="{'text-white': page.props.headerOptions?.inverted}"
            class="uppercase font-bold ">{{ activeLanguage?.code }}</p>
        </button>

        <div v-if="showDropdown"
            class="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
            <button v-for="lang in languages" :key="lang.code" @click="onSelectLanguage(lang.code)"
                :class="{ 'text-gray-400': lang.code === activeLangCode, 'hover:bg-gray-100': lang.code !== activeLangCode }"
                class="w-full flex px-4 py-2 text-sm font-semibold">
                {{ lang.name }}
            </button>
        </div>
    </div>
</template>
